<template>
	<div>
		<!-- Modal Reset Password-->
		<div class="layout mx-auto">
			<transition name="fade" appear>
				<div
					class="modal-overlay w-full"
					v-if="showModal"
					@click="showModal = false"
				></div>
			</transition>
			<transition name="slide" appear>
				<div class="modal text-navyBlue" v-if="showModal">
					<div>
						<h3 class=" text-2xl p-3">Lupa Password</h3>
						<button
							class="button text-xl float-right -mt-10 mr-6 outline-none focus:outline-none focus:bg-transparent active:bg-transparent"
							@click="showModal = false"
						>
							<b>x</b>
						</button>
					</div>
					<hr class="hr-text" />
					<p class="mx-3 pt-3">
						Silahkan masukkan email Anda untuk melakukan reset password.
					</p>
					<div class="text-left pt-3 pb-6">
						<div class="text-left p-8">
							<form @submit.prevent="reset">
								<label class="text-left"><b>Email</b></label>
								<br />
								<input
									class="px-3 py-2 mt-1 outline-none"
									required
									v-model="emailReset"
									type="text"
									placeholder="Email"
								/>
								<p class="mt-3 text-xs required">
									Pastikan email yang Kamu masukan benar.
								</p>
								<button
									class="button-login mt-20 outline-none focus:outline-none bg-lightPurple text-white w-full py-2 uppercase font-bold rounded-sm "
									type="submit"
								>
									<span class="button-login">{{
										authStatus ? authStatus : "Reset"
									}}</span>
								</button>
							</form>
						</div>
					</div>
				</div>
			</transition>
		</div>
		<!-- End Modal Reset Password-->
		<!-- Modal Success Reset-->
		<div class="layout mx-auto">
			<transition name="fade" appear>
				<div
					class="modal-overlay w-full"
					v-if="showSuccessModal"
					@click="showSuccessModal = false"
				></div>
			</transition>
			<transition name="slide" appear>
				<div class="modal text-navyBlue" v-if="showSuccessModal">
					<div>
						<h3 class=" text-2xl p-3">Link Tautan Dikirim</h3>
						<button
							class="button text-xl float-right -mt-10 mr-6 outline-none focus:outline-none focus:bg-transparent active:bg-transparent"
							@click="showSuccessModal = false"
						>
							<b>x</b>
						</button>
					</div>
					<hr class="hr-text" />
					<p class="mx-3 pt-3 ">
						Kami telah mengirimkan Kamu tautan untuk
						<b>me-reset ulang password</b>.<br />
						Silahkan cek email Kamu.
					</p>
					<div class="pb-20 pt-5">
						<img
							class="mx-auto"
							src="../../assets/static/svg/reset-icon.svg"
							alt="reset-icon"
						/>
					</div>
				</div>
			</transition>
		</div>
		<!-- End Modal Success Reset-->
		<div class="layout mx-auto">
			<div class="flex flex-col h-screen">
				<header>
					<div class="mx-auto pb-6 pt-10">
						<img
							class="logo"
							src="../../assets/static/svg/joinme.svg"
							alt=""
							srcset=""
						/>
					</div>
					<div class="mx-5 pt-6">
						<img
							src="../../assets/dashboard/login/welcome-banner.webp"
							alt=""
							srcset=""
						/>
					</div>
					<div class="mx-5 my-6 text-navyBlue">
						<h3><h1 class="text-3xl">Buat Website Gratis</h1></h3>
						<p class="text-center mt-3 leading-tight">
							Sosmed bio, weeding, photography, videography, catalog.
						</p>
					</div>
				</header>
				<main class="mb-auto">
					<div class="mx-5 bg-red-300 mb-6">
						<div
							v-if="error.message"
							class=" w-full text-left mx-3 p-2 text-white "
						>
							<p class="px-5 py-2"><b>Info: </b>{{ error.message }}</p>
						</div>
					</div>

					<form class="login mx-5 text-navyBlue" @submit.prevent="login">
						<div class="text-left">
							<label>Email</label><br />
							<input
								class="px-3 py-2 mt-1 outline-none"
								required
								v-model="email"
								type="text"
								placeholder="Email"
							/>
						</div>
						<div class="text-left pt-3 pb-6">
							<label class="text-left">Password</label>
							<p
								@click="showModal = !showModal"
								class="float-right text-xs pt-2 -pb-2 underline cursor-pointer"
							>
								Lupa Password
							</p>
							<br />
							<div class="inset-y-0 right-0 flex items-center ">
								<input
									class="px-3 py-2 mt-1 outline-none "
									required
									v-model="password"
									:type="showPass ? 'text' : 'password'"
									placeholder="********"
								/>
								<img
									@click="showPassword"
									v-if="showPass"
									class="eye"
									src="../../assets/static/svg/eye-open.svg"
									alt=""
									srcset=""
								/>
								<img
									v-if="!showPass"
									@click="showPassword"
									class="eye"
									src="../../assets/static/svg/eye-close.svg"
									alt=""
									srcset=""
								/>
							</div>
						</div>
						<div></div>
						<button
							class="button-login outline-none focus:outline-none bg-lightPurple text-white w-full py-2 uppercase font-bold rounded-sm "
							type="submit"
						>
							<span class="button-login">{{
								authStatus ? authStatus : "Login"
							}}</span>
						</button>
					</form>
					<div class="text-center pt-3 pb-6">
						<p class="text-md text-navyBlue">
							Belum punya akun ?
							<router-link to="/register" class="font-bold"
								>Daftar Sekarang</router-link
							>
						</p>
					</div>
				</main>
				<footer>
					<div class=" mb-0 pb-0 h-full">
						<p class=" bg-navyBlue py-2 text-sm text-whiteBase">
							©2021 joinme.id | All Right Reserved
						</p>
					</div>
				</footer>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			email: "",
			password: "",
			emailReset: "",
			showPass: false,
			error: {
				message: "",
			},
			showModal: false,
			showSuccessModal: false,
		};
	},
	computed: {
		authStatus: function() {
			return this.$store.getters.authStatus;
		},
	},
	methods: {
		resetError: function() {
			this.error.message = "";
		},
		showPassword: function() {
			this.showPass = !this.showPass;
		},
		login: function() {
			//reset error
			this.resetError();
			//set variable
			let email = this.email;
			let password = this.password;
			this.$store
				.dispatch("login", { email, password })
				.then(() => {
					this.$router.push("/");
				})
				.catch((err) => {
					if (err.response.status < 201 || err.response.status == 400) {
						//
						this.error.message = err.response.data.error.message;
						//var data = err.response.data;
						//console.log(data);
						return;
					}
					this.error.message = "Server error - unknown error";
					return;
					//console.log("data data:", err);
				});
		},
		reset: function() {
			//this.showModal = false
			const requestOptions = {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ email: this.emailReset }),
			};
			fetch(
				process.env.VUE_APP_ENDPOINT +
					process.env.VUE_APP_VERSION +
					"/user/forget",
				requestOptions
			).then((response) => response.json());
			this.showModal = false;
			this.showSuccessModal = true;
		},
	},
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Karla:wght@400&display=swap");
p,
h1,
h2,
h3,
h4,
h5,
span {
	font-family: "Karla", sans-serif;
}
/* .logo {
	max-width: 200px;
	height: auto;
	margin: 0 auto;
} */
input[type="text"],
input[type="text"]:active,
input[type="text"]:focus,
input[type="text"]:hover,
input[type="password"],
input[type="password"]:active,
input[type="password"]:focus,
input[type="password"]:hover {
	border: 1px solid rgb(131, 131, 131);
	width: 100%;
	background-color: transparent;
}
.button-login {
	letter-spacing: 6px !important;
	font-weight: bold;
	font-size: 19px;
}
.eye {
	position: relative;
	margin-left: -30px;
	cursor: pointer;
}
.info {
	position: relative;
	cursor: pointer;
	max-width: 23px;
	height: auto;
}
.modal-overlay {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	height: 100%;
	z-index: 98;
	background-color: rgba(0, 0, 0, 0.3);
}
.modal {
	position: fixed;
	bottom: 0%;
	left: 50%;
	transform: translate(-50%, 0%);
	z-index: 99;

	width: 100%;
	/* max-width: 400px; */
	background-color: #fff;
	border-top-right-radius: 10px;
	border-top-left-radius: 10px;
}
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
	transition: transform 0.5s;
}

.slide-enter,
.slide-leave-to {
	transform: translateX(-50%) translateY(100vw);
}
.required:before {
	content: "* ";
	color: red;
}
</style>
